import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import NoResults from "../NoResults/NoResults";

const ErrorView = styled(NoResults)`
  padding-top: 108px;
  padding-bottom: 64px;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobileL}) {
    padding-top: 64px;
  }
`;

const FetchDataError = () => {
  const { t } = useTranslation();

  return (
    <ErrorView
      title={t("something-went-wrong")}
      subtitle={t("working-on-a-fix")}
    />
  );
};

export default FetchDataError;
